DialogController = App.loadClass 'core::Angular/DialogController'

class exports.RxWarningController extends DialogController
    constructor: (@scope, @transitions, @modalInstance) ->

        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Charge Confirmation'
        @scope.absolute_errors = false
